import { $post } from '@/api/http.js'
import tool from '@/util/tool.js'
import common from "@/api/common.js"
import router from '@/router'
class FreeLand{
    /**
     * 获取免费土地列表
     * @param {number} page 
     * @param {number} limit 
     * @param {function} fn 
     */
    getFreeLand(page,limit,fn){
        let param = { page,limit }
        common.getDataList("landGivesList",param).then(res=>fn(res))
    }

    /**
     * 获取免费土地详情
     * @param {number} id 
     * @param {function} fn 
     */
    getFreeLandDetail(id,fn){
        $post("landGivesDetails",{id}).then(res=>fn(res.data))
    }

    /**
     * 删除免费土地
     * @param {number} id 
     * @param {function} fn 
     */
    deleteFreeLand(id,fn){
        tool.confirm("确认删除此活动信息吗？").then(()=>{
            $post("landGivesDelete",{id}).then(res=>{
                tool.message("删除成功")
                fn(res.data)
            })
        }).catch(()=>{})
    }

    /**
     * 新增或编辑免费地块活动
     * @param {object} param 
     */
    addOrEditFreeLand(param){
        if( !tool.returnMessage(param.land_id,'请选择地块')) return

        if( !param.id ) delete param.id
        param.land_give_area = JSON.stringify(param.land_give_area)
        $post("landGivesCreateOrEdit",param).then(()=>{
            tool.message("保存成功")
            router.go(-1)
        })
    }

    /**
     * 获取免费地块领取列表
     * @param {number} page 
     * @param {number} limit 
     * @param {function} fn 
     */
    getFreeLandGet(page,limit,fn){
        let param = { page,limit}
        common.getDataList("landGiveList",param).then(res=>fn(res))
    }

    /**
     * 操作免费地块列表数据
     * @param {string} type 
     * @param {number} id 
     * @param {function} fn 
     */
    handleFreeLandGet(type,id,fn){
        let title = type == "del" ?"确认禁用该领取信息吗？":"确认恢复该领取信息吗？"
        tool.confirm(title).then(()=>{
            $post("delOrRecoveryLandOrder",{op:type,id}).then(res=>{
                tool.message("操作成功")
                fn(res.data)
            })
        }).catch(()=>{})
    }
}

const freeLandModel = new FreeLand()
export default freeLandModel